export const aggregatePagedApiResponse = ({
  request,
  baseArgs,
  getNextCursor,
  merger
}) => {
  return request(baseArgs).then(resp => {
    const nextCursor = getNextCursor(resp);
    if (nextCursor) {
      return aggregatePagedApiResponse({
        request,
        baseArgs: Object.assign({}, baseArgs, {
          nextCursor
        }),
        getNextCursor,
        merger
      }).then(innerResp => {
        return merger(resp, innerResp);
      }).catch(err => {
        console.error(err);
        throw err;
      });
    }
    return resp;
  }).catch(err => {
    console.error(err);
    throw err;
  });
};